import { useState, useEffect } from 'react';

/**
 * Hook to track user idle time
 * 
 * @returns {Object} containing:
 *  - idleTime: number of minutes user has been idle
 *  - resetIdleTime: function to reset the idle time counter
 */
export const useIdleTime = () => {
  const [idleTime, setIdleTime] = useState(0);
  const [lastActivity, setLastActivity] = useState(Date.now());

  // Function to reset idle time
  const resetIdleTime = () => {
    setIdleTime(0);
    setLastActivity(Date.now());
  };

  // Set up event listeners to track user activity
  useEffect(() => {
    const activityEvents = [
      'mousedown', 'mousemove', 'keypress', 
      'scroll', 'touchstart', 'click', 'keydown'
    ];
    
    const handleActivity = () => {
      resetIdleTime();
    };

    // Add event listeners for user activity
    activityEvents.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    // Set up interval to check idle time
    const intervalId = setInterval(() => {
      const now = Date.now();
      const inactiveTimeMs = now - lastActivity;
      const inactiveTimeMinutes = Math.floor(inactiveTimeMs / (1000 * 60));
      
      setIdleTime(inactiveTimeMinutes);
    }, 60000); // Check every minute

    // Clean up event listeners and interval
    return () => {
      activityEvents.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
      clearInterval(intervalId);
    };
  }, [lastActivity]);

  return { idleTime, resetIdleTime };
};